import { useEffect, useState } from "react";
import { resolve_domain } from "../api";

export function useInitialPage() {
  const [pageId, setPageId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const host = window.location.hostname;

    console.group("[useInitialPage]");
    console.log("🌍 hostname:", host);

    // dominio principal → NO hacemos nada especial
    if (
      host.includes("trydeepco.com") ||
      host.includes("localhost")
    ) {
      console.log("🏠 Main domain detected → using normal router");
      setLoading(false);
      console.groupEnd();
      return;
    }

    console.log("🔍 Custom domain detected → resolving…");

    resolve_domain(host)
      .then((data) => {
        console.log("📦 resolve_domain response:", data);

        if (data?.businessId) {
          console.log("✅ Business resolved:", data.businessId);
          setPageId(data.businessId);
        } else {
          console.warn("⚠️ No businessId returned for domain:", host);
        }
      })
      .catch((err) => {
        console.error("❌ Error resolving domain:", err);
      })
      .finally(() => {
        console.log("⏳ Resolution finished");
        setLoading(false);
        console.groupEnd();
      });
  }, []);

  return { pageId, loading };
}
